export default __webpack_public_path__ + "static/media/icon snap_15398582.089b5b55.svg";